import React from "react";
import HeadingSample from "../components/utility/headingSample";
import { motion } from "framer-motion";

const sec1Subtitle = "";
const sec1Title = ["Roadmap", "#F8D835"];

const Roadmap: React.FC = () => {
  return (
    <div className="w-full flex flex-col items-center justify-center bg-white box-border overflow-hidden">

      <motion.div
        id="roadmap_home"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="h-[500px] sm:h-[700px] w-full bg-[url('../public/roadmap/section1.svg')] bg-black/30 bg-blend-overlay bg-cover bg-center"
      >
        <HeadingSample subtitle={sec1Subtitle} title={sec1Title} />
      </motion.div>
      {/* -----------section2------------------ */}
      <div id="future_Plans" className="w-full flex flex-col justify-center items-center bg-white px-4 sm:px-6 md:px-10 lg:px-12">
        <motion.div
          className="w-full flex flex-col lg:flex-row justify-center items-center gap-6 sm:gap-10 lg:gap-12 py-8"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="w-full p-2 sm:p-8 lg:p-16">
            <div id="future_plans" className="w-full max-w-7xl h-auto flex flex-col justify-center items-center p-2 py-6 sm:p-10 gap-4 rounded-[36px] shadow-lg mx-auto" >
              <div className="w-full  flex flex-col justify-center items-center gap-4 sm:gap-6">
                <div className="md:border-l-4 border-[#172B6B] px-4 text-[#172B6B] text-lg sm:text-xl lg:text-2xl  font-montserrat font-bold z-30">
                  Strategic roadmap for the launch and development of the Mineralex Utility and RWA tokenization project. Phases, milestones, and key activities necessary to establish a robust framework for utility and asset-backed tokens.
                </div>
                <img src="/roadmap/phase.png" alt="roadmap_phase" className="w-auto h-full max-h-screen"/>

              </div>
              {/* <div className="w-full flex flex-col lg:flex-row justify-center lg:justify-between items-center gap-8 p-4  text-center"> */}
              {/* Phrae 1 */}
              {/* <div className="w-full h-fit lg:w-1/3 flex flex-col justify-center items-center">
                  <div className="w-full flex flex-col justify-center items-center gap-4">
                    <div className="text-24px font-semibold text-black">Phrae 1</div>
                    <div className="w-full flex flex-col justify-center items-center">
                      Utility Token fundraising ($30M)
                    </div>
                  </div>
                  <svg className="w-full h-auto" viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50,40 L90,40 A40,40 0 0,1 50,80 Z" fill="#FFE564" />
                    <rect x="50" y="40" width="40" height="5" fill="#F8D835" />
                    <rect x="50" y="40" width="5" height="40" fill="#F8D835" />
                    <line x1="50" y1="10" x2="50" y2="30" stroke="#2A356F" strokeWidth="0.5" />
                    <circle cx="50" cy="40" r="12" fill="#2A356F" />
                    <circle cx="50" cy="40" r="5" fill="white" />
                    <circle cx="50" cy="40" r="2" fill="#2A356F" />
                  </svg>
                </div> */}

              {/* Phrae 2 */}
              {/* <div className="w-full h-fit lg:w-1/3 flex flex-col justify-center items-center">
                  <svg className="w-3/4 h-auto" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                    <line x1="-1000" y1="60" x2="1000" y2="60" stroke="#9DA3C0" strokeWidth="1" />
                    <line x1="60" y1="72" x2="60" y2="100" stroke="#9DA3C0" strokeWidth="1" />
                    <path d="M60,0 A60,60 0 0,1 120,60 L60,60 Z" fill="#F8D835" />
                    <path d="M60,10 A50,50 0 0,1 110,60 L60,60 Z" fill="#FFE564" />
                    <circle cx="60" cy="60" r="12" fill="#2A356F" />
                    <circle cx="60" cy="60" r="5" fill="white" />
                    <circle cx="60" cy="60" r="2" fill="#2A356F" />
                    <line x1="60" y1="60" x2="60" y2="48" stroke="#2A356F" strokeWidth="1" />
                  </svg>
                  <div className="w-full flex flex-col justify-center items-center gap-4">
                    <div className="text-24px font-semibold text-black">Phrae 2</div>
                    <div className="w-full flex flex-col justify-center items-center">
                      Utility Token fundraising ($30M)
                    </div>
                  </div>
                </div> */}

              {/* Phrae 3 */}
              {/* <div className="w-full h-fit lg:w-1/3 flex flex-col justify-center items-center gap-4">
                  <div className="w-full flex flex-col justify-center items-center gap-4">
                    <div className="text-24px font-semibold text-black">Phrae 3</div>
                    <div className="w-full flex flex-col justify-center items-center">
                      Large-scale mining operations, M&A opportunities
                    </div>
                  </div>
                  <svg className="w-full h-auto" viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50,40 L90,40 A40,40 0 0,1 50,80 Z" fill="#FFE564" />
                    <rect x="50" y="40" width="40" height="5" fill="#F8D835" />
                    <rect x="50" y="40" width="5" height="40" fill="#F8D835" />
                    <line x1="50" y1="10" x2="50" y2="30" stroke="#2A356F" strokeWidth="0.5" />
                    <circle cx="50" cy="40" r="12" fill="#2A356F" />
                    <circle cx="50" cy="40" r="5" fill="white" />
                    <circle cx="50" cy="40" r="2" fill="#2A356F" />
                  </svg>
                </div> */}
              {/* </div> */}

            </div>
          </div>

        </motion.div>


      </div>

      {/* <EventsAndReports/> */}
    </div>
  );
};

export default Roadmap;
